module.exports = __webpack_public_path__ + "static/media/piece2.e5666989.png";